import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Box, Container } from "@material-ui/core";
import {
  ErrorOutline as ErrorOutlineIcon,
  Description as DescriptionIcon,
  DateRange as DateRangeIcon,
  TableChartOutlined as TableIcon,
  Class,
  Assignment,
  Assessment,
  PlaylistAddCheck
} from "@material-ui/icons";
import SquareButton from "../../../waybee-ui/SquareButton";
import { Can } from "../../../acl/can";

const GroupActions = props => {
  const redirectTo = route => {
    const { history } = props;
    const { pathname } = history.location;
    history.push(`${pathname}${route}`);
  };

  return (
    <Box mt={2}>
      <Container maxWidth="xg">
        <Box display="flex" justifyContent="center" flexWrap="wrap">
          <Box px={2} pt={2}>
            <SquareButton
              icon={Assessment}
              color="primary"
              onClick={() => redirectTo("/reports")}
            >
              Relatórios
            </SquareButton>
          </Box>
          <Can I="use module" a="MASS_OCCURRENCES">
            <Box px={2} pt={2}>
              <SquareButton
                icon={ErrorOutlineIcon}
                color="primary"
                onClick={() => redirectTo("/occurrences")}
              >
                Ocorrências e faltas
              </SquareButton>
            </Box>
          </Can>

          <Can I="use module" a="SCORES_V1">
            <Box px={2} pt={2}>
              <SquareButton
                icon={DescriptionIcon}
                color="primary"
                onClick={() => redirectTo("/grades")}
              >
                Notas V1
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="SCORES_V2">
            <Box px={2} pt={2}>
              <SquareButton
                icon={DescriptionIcon}
                color="primary"
                onClick={() => redirectTo("/gradesV2")}
              >
                Notas V2
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="GRID_FREQUENCY">
            <Box px={2} pt={2}>
              <SquareButton
                icon={PlaylistAddCheck}
                color="primary"
                onClick={() => redirectTo("/frequency")}
              >
                Frequência
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="INDIVIDUAL_REPORT">
            <Box px={2} pt={2}>
              <SquareButton
                icon={TableIcon}
                color="primary"
                onClick={() => redirectTo("/individualReport")}
              >
                Relatório Individual
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="CLASS_PLAN">
            <Box px={2} pt={2}>
              <SquareButton
                icon={Class}
                color="primary"
                onClick={() => redirectTo("/plan")}
              >
                Plano de Aula
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="SCHEDULE">
            <Box px={2} pt={2}>
              <SquareButton
                icon={DateRangeIcon}
                color="primary"
                onClick={() => redirectTo("/schedule")}
              >
                Horários da turma
              </SquareButton>
            </Box>
          </Can>
          <Can I="use module" a="OCCURRENCES">
            <Box px={2} pt={2}>
              <SquareButton
                icon={Assignment}
                color="primary"
                onClick={() => redirectTo("/individualOccurrences")}
              >
                Ocorrências
              </SquareButton>
            </Box>
          </Can>
        </Box>
      </Container>
    </Box>
  );
};

GroupActions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired // Injected by withRouter
};

export default withRouter(GroupActions);
